// The "RBP NPR item" marker on a cart line the store's RBP Shopping List added (SL1.0
// `get_orders_cost.php:317`). SL1.0 marks the line whatever part of it came from the list, so the
// label has no "N of M" form. The part shown is `min(rbpQuantity, quantity)`, as the server caps it.
import type { BasketLine } from '../api/basket.client';

export const RBP_CART_LABEL = 'RBP NPR item';

/** "RBP NPR item" when any of the line came from the RBP Shopping List, else null. */
export function rbpCartLabel(line: Pick<BasketLine, 'quantity' | 'rbpQuantity'>): string | null {
  return Math.min(line.rbpQuantity ?? 0, line.quantity) > 0 ? RBP_CART_LABEL : null;
}
